module.exports = __webpack_public_path__ + "img/map.446cbc4d.png";